import * as React from 'react';
import * as FontAwesome from 'react-fontawesome';
import { connect, Dispatch } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { ApplicationState } from '../../data/applicationStates';
import { headerActionCreators } from '../../data/header/headerActions';
import { HeaderState } from '../../data/header/headerModels';
import './opportunities.css';
// import * as shortId from 'shortid';
// tslint:disable-next-line:no-var-requires
const moment = require('moment');
// require('moment/locale/sv');
// tslint:disable-next-line:no-var-requires
const orders = require('../../resources/orders.png');
import Modal from '../../components/modal/modal';
import Table from '../../components/table/table';
import { DataType, RowObject, Tbody } from '../../components/table/tableModels';
import {
    OpportunitiesClient,
    OpportunityHeadRate,
    OpportunityHeadStatusCode,
    StatusCode
} from '../../data/apiClient/client';
import { opportunitiesActionCreators } from '../../data/opportuneties/opportunetisActions';
import { ApiOpportunitiesState } from '../../data/opportuneties/opportunetisModels';

interface OpportunitiesState {
    opportunities: ApiOpportunitiesState;
    header: HeaderState;
}

interface OpportunitiesActions {
    opportunitiesActions: typeof opportunitiesActionCreators;
    headerActions: typeof headerActionCreators;
}

type OpportunitiesProps = OpportunitiesState & // ... state we've requested from the Redux store
    OpportunitiesActions & // ... plus action creators we've requested
    RouteComponentProps<{}>; // ... plus incoming routing parameters

interface State {
    tHead: Array<RowObject>;
    OpportunitiesList: Array<Tbody>;
    confirmationModalId: string;
    selectedOpportunetyStatus?: boolean;
    selectedOpportunityid?: string;
}

class Opportunities extends React.Component<OpportunitiesProps, State> {
    OC: OpportunitiesClient = new OpportunitiesClient();
    constructor(props: OpportunitiesProps) {
        super(props);
        this.state = {
            confirmationModalId: 'CONFIRMATIONMODAL',
            tHead: [
                new RowObject(DataType.string, 'Name', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'Company', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'City', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'State', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'Phone', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'Email', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'Date', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'Topic', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'Industry', undefined, undefined, 'pointer'),
                new RowObject(DataType.element, 'Rate', undefined, undefined, 'pointer'),
                new RowObject(DataType.element, 'Status', undefined, undefined, undefined)
                // ,
                // new RowObject(DataType.string, 'OrderId', undefined, undefined, 'pointer')
            ],
            OpportunitiesList: [],
            selectedOpportunetyStatus: undefined,
            selectedOpportunityid: undefined
        };
        this.onCloseOpportunity = this.onCloseOpportunity.bind(this);
        this.returnStatus = this.returnStatus.bind(this);
    }

    onCloseOpportunity() {
        if (this.state.selectedOpportunityid && this.state.selectedOpportunetyStatus !== undefined) {
            this.OC.setStatus(
                this.state.selectedOpportunityid,
                this.state.selectedOpportunetyStatus ? StatusCode.Won : StatusCode.Lost
            )
                .then(() => {
                    this.props.opportunitiesActions.GetOpportunities();
                })
                .catch((err) => {
                    // console.log(err);
                });
        }
    }

    returnStatus(statusCode: OpportunityHeadStatusCode, opportunityid?: string) {
        switch (statusCode) {
            case 'open':
                return (
                    <div>
                        <button
                            className="btn btn-outline-success mr-2 mb-1 tableButtonWidth"
                            data-toggle="modal"
                            data-target={'#' + this.state.confirmationModalId}
                            onClick={(event) => {
                                this.setState({
                                    selectedOpportunetyStatus: true,
                                    selectedOpportunityid: opportunityid
                                });
                                event.stopPropagation();
                                event.preventDefault();
                            }}
                        >
                            Mark as won
                        </button>
                        <button
                            className="btn btn-outline-danger mb-1 tableButtonWidth"
                            data-toggle="modal"
                            data-target={'#' + this.state.confirmationModalId}
                            onClick={(event) => {
                                this.setState({
                                    selectedOpportunetyStatus: false,
                                    selectedOpportunityid: opportunityid
                                });
                                event.stopPropagation();
                                event.preventDefault();
                            }}
                        >
                            Mark as lost
                        </button>
                    </div>
                );
            case 'won':
                return (
                    <div>
                        <span className="badge badge-success">Won</span>
                    </div>
                );
            case 'lost':
                return (
                    <div>
                        <span className="badge badge-danger">Lost</span>
                    </div>
                );
            default:
                return <React.Fragment />;
        }
    }

    getRateIcon(rate: OpportunityHeadRate) {
        switch (rate) {
            case 'hot':
                return <div className="rateCircleHot">H</div>;
            case 'warm':
                return <div className="rateCircleWarm">W</div>;
            case 'cold':
                return <div className="rateCircleCold">C</div>;
            default:
                return <React.Fragment />;
        }
    }

    componentWillMount() {
        this.props.headerActions.setBottomHeader('My Quick Solutions Online');
        this.getTbody(this.props);
    }

    componentDidUpdate(prevProps: OpportunitiesProps) {
        if (this.props.opportunities.opportunities !== prevProps.opportunities.opportunities) {
            if (this.props.opportunities.opportunities.length > 0) {
                this.getTbody(this.props);
            } else {
                // this.setState({ loading: false });
            }
        }
    }

    getOpportunitie(index: number) {
        this.props.history.push('/opportunitie/' + index);
    }

    getOpportunities(orderId: string) {
        this.props.history.push('/order/' + orderId);
    }

    getTbody(props: OpportunitiesProps) {
        let OpportunitiesList = new Array<Tbody>();

        OpportunitiesList = props.opportunities.opportunities.map((data, index) => {
            const rBody = new Array<RowObject>();

            rBody.push(new RowObject(DataType.string, data.name ? data.name : '', null, undefined, undefined));

            rBody.push(new RowObject(DataType.string, data.company ? data.company : '', null, undefined, undefined));

            rBody.push(new RowObject(DataType.string, data.city ? data.city : '', null, undefined, undefined));

            rBody.push(new RowObject(DataType.string, data.state ? data.state : '', null, undefined, undefined));

            rBody.push(
                new RowObject(DataType.string, data.phonenumber ? data.phonenumber : '', null, undefined, undefined)
            );

            rBody.push(new RowObject(DataType.string, data.email ? data.email : '', null, undefined, undefined));

            rBody.push(
                new RowObject(
                    DataType.string,
                    data.createdDate ? moment(data.createdDate, 'M/D/YYYY').format('M/D/YYYY') : '',
                    null,
                    undefined,
                    undefined
                )
            );

            rBody.push(new RowObject(DataType.string, data.topic ? data.topic : '', null, undefined, undefined));
            rBody.push(new RowObject(DataType.string, data.industry ? data.industry : '', null, undefined, undefined));

            rBody.push(
                new RowObject(DataType.string, data.rate ? this.getRateIcon(data.rate) : '', null, undefined, undefined)
            );

            rBody.push(
                new RowObject(
                    DataType.element,
                    data.statusCode ? this.returnStatus(data.statusCode, data.opportunityid) : '',
                    null,
                    undefined,
                    undefined
                )
            );

            const row = new Tbody(rBody, data.opportunityid, this.getOpportunitie.bind(this));

            return row;
        });
        this.setState({ OpportunitiesList: OpportunitiesList });
    }

    public render() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="componentHeader">
                        <div className="item tile">
                            <div className="tileHead">
                                <div className="float-left">
                                    <h4>{'Opportunities'}</h4>
                                </div>
                                <div className="tileImage float-right">{<img src={orders} />}</div>
                            </div>
                            <div className="tileBody">
                                <div className="topBorder" />
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.OpportunitiesList.length > 0 ? (
                    <Table
                        tHead={this.state.tHead}
                        tBody={this.state.OpportunitiesList}
                        listSize={this.props.opportunities.opportunities.length}
                        hover={true}
                        hidePagination={true}
                        americanDateFormat={true}
                    />
                ) : this.props.opportunities.loading ? (
                    <div className="centerThis">
                        <FontAwesome className="progressicon" name="spinner" size="3x" spin={true} />
                    </div>
                ) : (
                    <div className="centerThis">Sorry. No opportuneties.</div>
                )}
                <Modal
                    id={this.state.confirmationModalId}
                    modalBody={<h4>Are you sure you want to close this opportunity?</h4>}
                    modalFooter={
                        <React.Fragment>
                            <button data-dismiss="modal" className="btn btn-success" onClick={this.onCloseOpportunity}>
                                {this.state.selectedOpportunetyStatus ? 'Close as won' : 'Close as lost'}
                            </button>
                            <button className="btn btn-error" data-dismiss="modal">
                                {'Cancel'}
                            </button>
                        </React.Fragment>
                    }
                />
            </div>
        );
    }
}

export function mapStateToProps(state: ApplicationState): OpportunitiesState {
    return {
        opportunities: state.opportunities,
        header: state.header
    };
}

function mapDispatchToProps(dispatch: Dispatch<{}>): OpportunitiesActions {
    return {
        opportunitiesActions: bindActionCreators(opportunitiesActionCreators, dispatch),
        headerActions: bindActionCreators(headerActionCreators, dispatch)
    };
}

export default withRouter(
    connect(
        mapStateToProps, // Selects which state properties are merged into the component's props
        mapDispatchToProps // Selects which action creators are merged into the component's props
    )(Opportunities)
);



// WEBPACK FOOTER //
// ./src/containers/Opportunities/opportunities.tsx